import type { ProductVariantOptionImagePattern, Multipack } from './types/index'

export const POPUP_PRESENTS_ID = 'sb-popup-cart-presents'

export const ANY_VARIANT_OPTION_IMAGE_REGEX_WITH_INDEX: ProductVariantOptionImagePattern =
  {
    regex: new RegExp(`-(any)`, 'i'),
    regexWithIndex: new RegExp(`-(any)-(\\d+)`, 'i'),
  }

export const MARKETS: string[] = ['ALL', 'DE', 'AT', 'CH', 'INT', 'FR']

/**
 * Default counts of items in a multipack and the discount
 */
export const DEFAULT_MULTIPACK: Multipack = {
  quantity: 1,
  percentage: 0,
  active: true,
}

export enum VALIDATE_QUANTITY_ERROR {
  LessThanMin = 'lessThanMin',
  MoreThanMax = 'moreThanMax',
}
